import React, { createContext } from 'react';

import { MessagingClient } from './createMessagingClient';

export const MessagingClientContext = createContext<MessagingClient | null>(null);

interface Props {
    messagingClient: MessagingClient;
}

export const MessagingProvider: React.FC<Props> = ({ messagingClient, children }) => {
    return (
        <MessagingClientContext.Provider value={messagingClient}>
            {children}
        </MessagingClientContext.Provider>
    );
};
